import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslateModule} from '@ngx-translate/core';
import {FieldComponent} from '../field/field.component';

@Component({
    selector: "woa-email-field",
    templateUrl: "./email-field.component.html",
    styleUrl: "./email-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: EmailFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailFieldComponent extends AbstractField {
    public readonly autocomplete: InputSignal<"email" | "username"> = input<"email" | "username">("email");
    public readonly maxlength: InputSignal<string> = input<string>("60");
}
